/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Corrects the order of a list of objects with a position property (1-based).
 * 
 * Mutates the objects inside of the array
 * @template {PositionalItem} T
 * @param {T[]} items 
 */
export function correctPosition (items) {
    items.forEach((item, index) => {
        item.position = index + 1;
    });
}
